import script from "./AlternativesViewDeleterDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlternativesViewDeleterDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AlternativesViewDeleterDialog.vue?vue&type=style&index=0&id=d0d9d77c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0d9d77c"]])

export default __exports__